module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vendo8-2cfa7180ad10d6cd3ad836ee8e2df23d.jpg";